import s from './Estados.module.css';

export function Carregando({ texto = 'Carregando…' }: { texto?: string }) {
  return (
    <div className={s.centro}>
      <div className={s.caixa}><div className={s.texto}>{texto}</div></div>
    </div>
  );
}

/**
 * Modulo que o usuario nao pode ver.
 *
 * Isto e UX, NAO seguranca: esconder a rota nao protege nada. Quem barra
 * acesso e a API, em todo request. Se o servidor responder dados a quem
 * nao devia, esta tela nao ajuda em nada.
 */
export function SemAcesso({ modulo }: { modulo?: string }) {
  return (
    <div className={s.centro}>
      <div className={s.caixa}>
        <div className={s.titulo}>Sem acesso</div>
        <div className={s.texto}>
          Seu usuário não tem perfil para acessar este módulo
          {modulo ? ` (${modulo})` : ''}.
        </div>
      </div>
    </div>
  );
}

export function NaoEncontrado() {
  return (
    <div className={s.centro}>
      <div className={s.caixa}>
        <div className={s.titulo}>Página não encontrada</div>
        <div className={s.texto}>O endereço acessado não existe.</div>
      </div>
    </div>
  );
}

/** A API nao respondeu /api/auth/me: sem isso nao da para montar nada. */
export function SessaoIndisponivel({ erro }: { erro: Error }) {
  return (
    <div className={s.centro}>
      <div className={s.caixa}>
        <div className={s.titulo}>Sessão indisponível</div>
        <div className={s.texto}>
          Não foi possível confirmar quem você é. A API está no ar?
        </div>
        <div className={s.codigo}>
          uvicorn api.main:app --reload --port 8000
          <br />
          {erro.message}
        </div>
      </div>
    </div>
  );
}
